<div class="dialog-header">
  <div class="header-content">
    <div class="header-icon">
      <mat-icon>draw</mat-icon>
    </div>
    <div class="header-text">
      <h2 mat-dialog-title>
        {{ 'createDoc.signatureCaptureDialog.title' | transloco }}
      </h2>
      <p class="header-subtitle">
        {{ (data.existingSignatureImageId != null ? 'createDoc.signatureCaptureDialog.subtitleExisting' : 'createDoc.signatureCaptureDialog.subtitle') | transloco: { personName: data.personName } }}
      </p>
    </div>
  </div>
  <button mat-icon-button color="primary" (click)="onCancel()" type="button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <mat-tab-group [dynamicHeight]="true" [selectedIndex]="activeTab" (selectedIndexChange)="setTab($event)">
    <mat-tab [label]="'createDoc.signatureCaptureDialog.uploadTab' | transloco">
      <div class="tab-content">
        <ng-container *ngIf="!uploadedBlob">
          <div class="upload-dropzone">
            <input #fileInput type="file" hidden [attr.accept]="allowedImageTypes.join(',')" (change)="onFileSelected($event)" />
            <div class="upload-icon">
              <mat-icon>upload</mat-icon>
            </div>
            <span class="upload-hint">{{ 'createDoc.signatureCaptureDialog.uploadHint' | transloco }}</span>
            <button mat-stroked-button color="primary" type="button" (click)="fileInput.click()">
              {{ 'createDoc.signatureCaptureDialog.selectFile' | transloco }}
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="uploadedBlob">
          <div class="signature-preview">
            <img [src]="uploadedPreviewUrl" [alt]="data.personName" />
          </div>
          <button mat-button type="button" class="clear-button" (click)="removeUploadedImage()">
            <mat-icon>close</mat-icon>
            {{ 'common.buttons.delete' | transloco }}
          </button>
        </ng-container>
      </div>
    </mat-tab>

    <mat-tab [label]="'createDoc.signatureCaptureDialog.drawTab' | transloco">
      <div class="tab-content">
        <canvas
          #signatureCanvas
          class="signature-canvas"
          width="680"
          height="260"
          (pointerdown)="startDrawing($event)"
          (pointermove)="draw($event)"
          (pointerup)="stopDrawing()"
          (pointerleave)="stopDrawing()">
        </canvas>
        <button mat-button type="button" class="clear-button" [disabled]="!hasDrawing" (click)="clearDrawing()">
          <mat-icon>refresh</mat-icon>
          {{ 'common.buttons.delete' | transloco }}
        </button>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="options-grid persistence-choice" *ngIf="data.showPersistenceChoice">
    <button
      type="button"
      class="option-card"
      [class.selected]="!saveToProfile"
      (click)="selectPersistChoice(false)">
      <h3 class="option-title">{{ 'createDoc.signatureCaptureDialog.useOnceTitle' | transloco }}</h3>
      <p class="option-description">{{ 'createDoc.signatureCaptureDialog.useOnceDescription' | transloco }}</p>
    </button>

    <button
      type="button"
      class="option-card"
      [class.selected]="saveToProfile"
      (click)="selectPersistChoice(true)">
      <h3 class="option-title">{{ 'createDoc.signatureCaptureDialog.saveAndUseTitle' | transloco }}</h3>
      <p class="option-description">{{ 'createDoc.signatureCaptureDialog.saveAndUseDescription' | transloco }}</p>
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button type="button" (click)="onCancel()">
    {{ 'common.buttons.cancel' | transloco }}
  </button>
  <button
    mat-raised-button
    color="primary"
    type="button"
    [disabled]="isSaving || (!hasSignature() && data.existingSignatureImageId == null)"
    (click)="onConfirm()">
    {{ data.confirmButtonLabel || ('common.buttons.save' | transloco) }}
  </button>
</mat-dialog-actions>
